module.exports = __webpack_public_path__ + "img/spedy.eacb50c9.svg";